import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
//Sections
import Admin from "./pages/administration";
import Login from "./pages/login";
import RecoverPassword from "./pages/login/recoverPassword";
import { ProtectedRoute } from "./components/security/protectedRoute";
//Functions
import useLanguage from "./functions/useLanguage";

import { useLogoutSync } from "./hooks/useLogout";

function SessionSync() {
  useLogoutSync();
  return null;
}

function App() {
  useLanguage();
  return (
    <Router>
      <SessionSync />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/resetpassword/:token" element={<RecoverPassword />} />
        <Route path="/change-password/:token" element={<RecoverPassword />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute page="admin">
              <Admin />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Login />} />
      </Routes>
    </Router>
  );
}

export default App;
